"use client";

import { c as _c } from "react/compiler-runtime";
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

//#region [Props]
type YoutubeEmbedProps = {
  title: string;
  youtubeId: string;
};
//#endregion

// https://ibrahimcesar.github.io/react-lite-youtube-embed/docs/api-reference

//#region [Component]
export default function YoutubeEmbed(t0) {
  const $ = _c(3);
  const {
    title,
    youtubeId
  } = t0;
  let t1;
  if ($[0] !== title || $[1] !== youtubeId) {
    t1 = <LiteYouTubeEmbed id={youtubeId} title={title} poster="maxresdefault" lazyLoad={true} />;
    $[0] = title;
    $[1] = youtubeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
//#endregion